module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog-card-wrap"
  }, [_c('div', {
    staticClass: "blog-card-container"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": _vm.blogLink
    }
  }, [_c('article', {
    staticClass: "blog-card"
  }, [_c('img', {
    staticClass: "post-image",
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.imageAlt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article-details"
  }, [_c('h4', {
    staticClass: "post-category"
  }, [_vm._v(_vm._s(_vm.category))]), _vm._v(" "), _c('h3', {
    staticClass: "post-title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
    staticClass: "post-description"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('p', {
    staticClass: "post-author"
  }, [_vm._v(_vm._s(_vm.date))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0550b6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BlogCard.vue
// module id = 1929
// module chunks = 5